"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    propsData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    marketPadding: function marketPadding() {
      var _this$propsData, _this$propsData2;
      if (!((_this$propsData = this.propsData) !== null && _this$propsData !== void 0 && _this$propsData.marketPadding)) return;
      var _ref = ((_this$propsData2 = this.propsData) === null || _this$propsData2 === void 0 ? void 0 : _this$propsData2.marketPadding) || {},
        pt = _ref.pt,
        pb = _ref.pb,
        pl = _ref.pl,
        pr = _ref.pr;
      return "".concat(pt || 0, "px ").concat(pr || 0, "px ").concat(pb || 0, "px ").concat(pl || 0, "px");
    }
  }
};